import Typography from '@/components/atoms/typography/typography';
import styles from './trip-route-accordion-headline.module.scss';

export interface TripRouteAccordionHeadlineProps {
  /** The headline for the accordion */
  headline: string;
  /** The sub headline for the accordion */
  subHeadline?: string;
}

const TripRouteAccordionHeadline = ({
  headline,
  subHeadline,
}: TripRouteAccordionHeadlineProps) => {
  return (
    <div className={styles.component}>
      <Typography tagStyle="headingMedium">{headline}</Typography>

      {subHeadline && (
        <Typography tagStyle="headingSmall">{subHeadline}</Typography>
      )}
    </div>
  );
};

TripRouteAccordionHeadline.displayName = 'TripRouteAccordionHeadline';

export default TripRouteAccordionHeadline;
